<template>
  <div>

    <v-card elevation="0" v-if="subject.length > 1">
      <v-card-title class="headline sticky" v-if="search && search.department">
        {{ search.department.F1 }} - {{ search.department.F0 }}
      </v-card-title>
      <v-card-text>
        <v-simple-table class="border position-relative">
          <template>
            <thead>
              <tr>
                <th>
                  {{ $store.state.lang.table_sorszam }}
                </th>
                <th>
                  {{ $store.state.lang.targy }}
                </th>
                <th>{{ $store.state.lang.targykod }}</th>
                <th>
                  {{ $store.state.lang.tanszek }}
                </th>
                <th>
                  {{ $store.state.lang.tanszekkod }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sub, index) in subject" :key="index">
                <td class="">{{ index + 1 }}</td>
                <td class="">
                  <a
                    href="javascript:void(0)"
                    class="text-decoration-none"
                    @click="tantargytematika(sub.F2)"
                    >{{ sub.F3 }}</a
                  >
                </td>
                <td class="">{{ sub.F2 }}</td>
                <td class="">{{ sub.F1 }}</td>
                <td class="">{{ sub.F0 }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-card elevation="0" v-if="subject.length == 1 && subject[0].F2">
      <v-card-title class="headline sticky">
        {{ subject[0].F3 }} - {{ subject[0].F2 }}
      </v-card-title>
      <v-card-text>
        <v-simple-table class="border">
          <template>
            <tbody>
              <tr>
                <td>Tárgy / Subject</td>
                <td>{{ subject[0].F3 }}</td>
              </tr>
              <tr>
                <td>Tárgykód / Subject Code</td>
                <td>{{ subject[0].F2 }}</td>
              </tr>
              <tr>
                <td>Tanszék / Department</td>
                <td>{{ subject[0].F1 }}</td>
              </tr>
              <tr>
                <td>Tanszék kód / Department code</td>
                <td>{{ subject[0].F0 }}</td>
              </tr>
              <tr v-for="(item, key) in subject[0].pdfs" :key="key">
                <td>
                  Tantárgytematika / Syllabus <b>{{ item }}</b>
                </td>
                <td>
                  <a @click="download(item, subject[0].F2)"
                    >Letöltés / Download</a
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-card class="mx-auto" v-if="!subject || ( subject[0] && !('F2' in subject[0]))">
      <v-card-text class="text-center py-8">
        <v-icon size="64" color="grey lighten-1">
          mdi-file-document-alert-outline
        </v-icon>

        <div class="text-h6 mt-4 mb-2">Nincs tantárgyi tematika</div>

        <div class="text-body-2 grey--text text--darken-1">
          Ehhez a tantárgyhoz még nem lett feltöltve tematika
        </div>
      </v-card-text>
    </v-card>

    <div class="text-center">
      <v-dialog v-model="dialog" width="1000px">
        <v-card class="pa-0 ma-0 position-relative">
          <v-card-title
            class="pa-3 d-flex justify-end position-sticky top-0 bg-white"
            style="z-index: 999"
          >
            <v-icon @click="dialog = false" class="text--primary"
              >mdi-close</v-icon
            >
          </v-card-title>
          <v-card-text class="ma-0 pa-0">
            <Tantargytematika :subject="[subsubject]" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tantargytematika",
  props: {
    subject: Array,
    search: Object,
  },
  data: () => ({
    pdfs: [],
    subpdfs: [],
    dialog: false,
    subsubject: {},
  }),
  mounted() {
    // console.log(this.subject);
  },
  methods: {
    async tantargytematika(index) {
      try {
        this.subsubject = this.subject.filter((item) => item.F2 == index)[0];
        const response = await this.$http.post("/getSubPdfs", this.subsubject);
        this.subsubject.pdfs = [];
        response.pdfs.forEach((element) => {
          this.subsubject.pdfs.push(element.Félév);
        });
        // this.subsubject.pdfs = response.pdfs;
        this.dialog = true;
      } catch (e) {
        console.error(e);
      }
    },

    async download(item, code) {
      try {
        var post = {
          code: code,
          felev: item,
        };
        const response = await this.$http.post("/downloadPdf", post);
        const link = document.createElement("a");
        link.setAttribute("target", "_blank");
        // link.href = 'https://tata.uninet.hu/api/tmp/' + item.link.pdf_hu + ".pdf";
        link.href = response.file;

        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
tr:nth-child(odd) {
  background-color: lighten(lightgrey, 14%);
}
a {
  display: inline-block;
  position: relative;
  padding: 0.2em 0;
  overflow: hidden;
}
a::after {
  content: "";
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 0.1em;
  transform: scaleX(0);
  background-color: #0c3c60;
  transform-origin: bottom right;
  // transition: transform 0.25s ease-out;
}
a:hover:after {
  transform: scale(1);
  transform-origin: bottom left;
  transition: transform 0.25s ease-in;
}
.sticky {
  position: sticky;
  z-index: 5;
  top: 40px;
  background-color: #fff;
}
</style>